import axios from 'axios'

/**
 * Pre-configured axios client. Today the app runs on the in-memory mock
 * layer, but this instance is wired for a real JWT backend: set
 * VITE_API_BASE_URL and the token interceptor below activates automatically.
 */
export const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api',
  timeout: 15_000,
  headers: { 'Content-Type': 'application/json' },
})

const TOKEN_KEY = 'mcsms.token'

export function setAuthToken(token: string | null) {
  if (token) localStorage.setItem(TOKEN_KEY, token)
  else localStorage.removeItem(TOKEN_KEY)
}

http.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY)
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

http.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      setAuthToken(null)
      // In a real deployment, redirect to /login here.
    }
    return Promise.reject(error)
  },
)
